/**
 * Internal dependencies
 */
import * as actions from 'state/action-types';
import { createReducer } from 'state/utils';

export default createReducer(false, {
	[actions.STARTUP_LOADED_SUCCESS]: (state) => {
		return true;
	},
});
